module.exports = __webpack_public_path__ + "static/media/IMG_20161024_215112.2a91e60a.jpg";